
import { createStore } from 'vuex';

export default createStore({
  state() {
    return {
        isTransferTextStatus: localStorage.getItem('isTransferTextStatus') || '0',
    };
  },
  mutations: {
    SET_TRANSFERTEXT(state,data) {
      state.isTransferTextStatus = data;
    }
  },
  actions: {
    changeTransferText(context, data) {
      context.commit('SET_TRANSFERTEXT', data);
      localStorage.setItem('isTransferTextStatus', data)
    }
  }
});
